import { createSlice } from '@reduxjs/toolkit'
import { CptCodeType, CptDetails } from '../types/cptCode.types'

const initialState: CptCodeType<CptDetails> = {
  content: [],
  selected: null,
  selectedProduct: null,
  totalPages: null,
}

const cptCodeSlice = createSlice({
  name: 'cptCode',
  initialState: initialState,
  reducers: {
    updateCptData: (state, action) => {
      state.content = action.payload
    },
    updateTotalPagesCpt: (state, action) => {
      state.totalPages = action.payload
    },
    updateSelectedCpt: (state, action) => {
      state.selected = action.payload
    },
    resetSelectedCpt: (state) => {
      state.selected = null
    },
    updateSelectedAddProductsCpt: (state, action) => {
      state.selectedProduct = action.payload
    },
    createCptCodeAction: () => {
      return
    },
    getAllCptCodeAction: () => {
      return
    },
    fetchCptCodeAction: () => {
      return
    },
    updateCptCodeByIdAction: () => {
      return
    },
    patchToggleUpdateDisableActionCptCode: () => {
      return
    },
    patchToggleUpdateEnableActionCptCode: () => {
      return
    },
    patchToggleUpdateBulkDisableActionCptCode: () => {
      return
    },
    patchToggleUpdateBulkEnableActionCptCode: () => {
      return
    },
    getSingleAddProductsCptAction: () => {
      return
    },
    getCptDataBySortAction: () => {
      return
    },
  },
})

export const {
  updateCptData,
  updateSelectedCpt,
  resetSelectedCpt,
  getAllCptCodeAction,
  createCptCodeAction,
  fetchCptCodeAction,
  updateCptCodeByIdAction,
  patchToggleUpdateDisableActionCptCode,
  patchToggleUpdateEnableActionCptCode,
  patchToggleUpdateBulkDisableActionCptCode,
  patchToggleUpdateBulkEnableActionCptCode,
  getSingleAddProductsCptAction,
  updateSelectedAddProductsCpt,
  getCptDataBySortAction,
  updateTotalPagesCpt,
} = cptCodeSlice.actions
export default cptCodeSlice.reducer
